// extracted by mini-css-extract-plugin
export var buttonContainer = "_90-1";
export var fontSizeSelect = "_90-3";
export var formatSelect = "_90-2";
export var formats = "_90-4";
export var hidden = "_90-5";
export var icon = "_90-6";
export var select = "_90-0";